import type { Route } from 'next';

// TODO: констатны не должны зависить от утилит, это неправильно
// eslint-disable-next-line boundaries/element-types
import { getAppUrl, getSubdomainUrlStr } from '~utils/host';

//as we type typed routes heres how it looks like now
type DeepRouteify<T> = T extends string
	? Route
	: T extends (...args: never[]) => string
	? (...args: Parameters<T>) => Route
	: T extends object
	? { [K in keyof T]: DeepRouteify<T[K]> }
	: T;

const routeify = <T>(obj: T): DeepRouteify<T> => obj as DeepRouteify<T>;

const getGenerateAccessTabRoutes = (type: 'images' | 'videos') => ({
	home: `/generate/${type}`, // Use to match prefix only
	my: `/generate/${type}`,
	liked: `/generate/${type}/liked`,
	unlocked: `/generate/${type}/unlocked`,
	community: `/generate/${type}/community`,
});

export const routes = routeify({
	index: '/',
	chats: {
		home: '/chats',
		dialog: (recipientId: string | number) => `/chats/${recipientId}`,
		sitemap: '/chats/sitemap.xml',
	},
	profile: {
		home: '/profile',
		slug: (slug: string | number) => `/profile/${slug}`,
		sitemap: '/profile/sitemap.xml',
	},
	// TODO: Maybe is able to change routes.explore.home: '/models'
	explore: {
		home: '/',
		models: '/characters',
		slug: (slug: string) => `/characters/${slug}`,
		sitemap: '/characters/sitemap.xml',
	},
	generate: {
		images: getGenerateAccessTabRoutes('images'),
		videos: getGenerateAccessTabRoutes('videos'),
		character: '/generate/character',
		sitemap: '/generate/sitemap.xml',
	},
	gallery: {
		home: '/gallery',
		slug: (slug: string) => `/gallery/${slug}`,
		singleHome: '/gallery/media', // Non-existent, match prefix only
		single: (slug: string | number) => `/gallery/media/${slug}`,
	},
	creator: {
		slug: (slug: string) => `/creator/${slug}`,
	},
	company: {
		about: '/about',
		advisory: '/advisory',
	},
	// service
	subscribe: {
		home: '/subscribe',
	},
	signin: {
		home: '/signin',
	},
	signup: {
		home: '/signup',
	},
	neurons: {
		home: '/neurons',
	},
	// legals
	terms: {
		home: '/terms',
		us: '/termsus',
	},
	privacy: {
		home: '/privacy',
		us: '/privacyus',
	},
	support: {
		home: '/support',
	},
	refund: {
		home: '/refund',
	},
	safety: {
		home: '/safety',
	},
	complaints: {
		home: '/complaints-policy',
	},
	auth: {
		discord: {
			signIn: '/auth/discord/signin',
			signUp: '/auth/discord/signup',
			connect: '/auth/discord/connect',
		},
	},
});

const appUrl = getAppUrl();
const creatorUrl = getSubdomainUrlStr('creator');

export const externalRoutes = {
	becomeAffiliate: `${appUrl}affiliate-program?_gl=1*13em0hd*_ga*OTQ4ODEyOTYxLjE3NDYwMTY0MTI.*_ga_6CSFHDT4QZ*MTc0NjAzMDI4OS4zLjAuMTc0NjAzMDI4OS4wLjAuMTUyMjc0Mzk3Nw..*_fplc*UUhsNEhBTEJ2RjEydDVvdWhVZlI4TWMlMkJYRHYyMGdoeU5lT3NIOFZKUiUyRkZFTGtITGxuYSUyQmQxSDJWcmh2Q2FqazhydjdjVFR0M0xZJTJGJTJCazNXUkNpaGhBTUkwdXFZZnJmQnl1UGtpWDd5VnVYY2J4NjdNb3M3dFREY21OTkZEQSUzRCUzRA`,
	creatorUrl: `${creatorUrl}?_gl=1*57pd7j*_ga*OTQ4ODEyOTYxLjE3NDYwMTY0MTI.*_ga_6CSFHDT4QZ*MTc0NjAyNDc1MC4yLjAuMTc0NjAyNDc1MC4wLjAuMTI4NTIwOTk3NQ..*_fplc*c2E3UGFNWFY4a2NwZFV0Rm8ycDFidGxpYmZqNUZyd0Y2NDlQaUlVM0lHd2tFTTg0ZFZpTlJ5bVRKeVRJeTdFZzdKSVVXN3BZdjl5cU1jWlQzOEFyZEVNcDBNWUI5ajR3ZXhZekN1QWFxc2ptUENlbEZhWENRbmM4bXpuVnhBJTNEJTNE`,
};
